import React, { useMemo } from 'react';
import { useExperiment } from 'statsig-react';

import useCampaign from '../../hooks/use_campaign';
import useTranslation from '../../hooks/use_translation';
import { createEvent } from '../../utils/tracking';
import Link from '../framework/link';
import Trustpilot from '../script/trustpilot';
import Trans from '../translation/trans';

const DEFAULT_ACTION_TEXT = 'text2';
const DEFAULT_VARIANT = 'primary';

const ActionCard = () => {
	const { discount, isActive } = useCampaign();
	const { config: experiment, isLoading: isLoadingExperiment } = useExperiment(
		'articles_action_card',
	);
	const { t } = useTranslation('component_action_card');

	const action_text = experiment.get('action_text', DEFAULT_ACTION_TEXT);
	const variant = experiment.get('variant', DEFAULT_VARIANT);

	const currentAction = useMemo(() => {
		const actions = {
			text_campaign: {
				buttons: [
					{
						text: 't4',
						url: '/halsokontroller/',
					},
				],
				content: 't5',
			},
			text2: {
				buttons: [
					{
						text: 't4',
						url: '/halsokontroller/',
					},
				],
				campaign_text: 't6',
				content: 't3',
			},
		};

		let out = null;
		if (actions[action_text]) out = actions[action_text];
		return out;
	}, [action_text]);

	const handleTracking = ({ id, text, type }) => {
		createEvent('button_click', {
			id,
			text,
			type,
		});
	};

	const variants = {
		primary: {
			boxColor: 'bg-primary',
			ctaColor: 'light',
			textColor: 'text-white',
			trustpilotTheme: 'dark',
		},
		primaryLight: {
			boxColor: 'bg-primary-light',
			ctaColor: 'dark',
			textColor: 'text-dark',
			trustpilotTheme: 'light',
		},
	};

	if (!currentAction || isLoadingExperiment) {
		return <></>;
	}

	return (
		<div
			className={`${variants[variant].boxColor} ${variants[variant].textColor} rounded-3 p-3 text-center text-lg-start`}
		>
			<p className="small fw-700 text-center mb-0">
				<Trans i18nKey={currentAction.content} t={t} />
			</p>
			{/* Campaign text */}
			{isActive && (
				<p className="small fw-700 text-center">
					<Trans
						i18nKey={currentAction.campaign_text}
						t={t}
						values={{
							discount_amount: discount.amount,
							discount_code: discount.code,
							discount_valid_until: discount.valid_until,
						}}
					/>
				</p>
			)}

			<div className="d-flex gap-1">
				{currentAction?.buttons?.map((item, index) => {
					return (
						<Link
							className={`btn btn-${variants[variant].ctaColor} rounded-pill w-100`}
							key={index}
							onClick={() =>
								handleTracking({
									id: index,
									text: t(item.text),
									type: 'action_card',
								})
							}
							to={item.url}
						>
							{t(item.text)}
						</Link>
					);
				})}
			</div>
			<hr className="" />
			<div className="">
				<Trustpilot
					theme={variants[variant].trustpilotTheme}
					type="micro_trust_score"
				/>
			</div>
		</div>
	);
};

export default ActionCard;
